// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorAlert__container__3huSL","icon":"ErrorAlert__icon__yp1ua"};